import {
    DEALERAPPROVEREJECTDSR_FAILED,
    DEALERAPPROVEREJECTDSR_SUCCESS,
    RESET_DEALERAPPROVEREJECTDSR,
    LOADING_DEALERAPPROVEREJECTDSR,
    NETWORK_ERROR_DEALERAPPROVEREJECTDSR
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERAPPROVEREJECTDSR:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERAPPROVEREJECTDSR_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERAPPROVEREJECTDSR_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERAPPROVEREJECTDSR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERAPPROVEREJECTDSR:
            return (state = initialState);
        default:
            return state;
    }
};